import React from "react";
import styled from "styled-components";
import { usePilotageRhStore } from "../../store/usePilotageRhStore";
import useIndicatorsVisibility from "../../hooks/useIndicatorsVisibility";
import { FloatingDockPortal } from "../../../../components/FloatingDock/FloatingDock";
import { prhTheme } from "../../styles/theme";

const SlidersIcon = () => (
    <svg
        width="15"
        height="15"
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
    >
        <path d="M2 4.5h7M12 4.5h2M2 11.5h2M7 11.5h7" />
        <circle cx="10.5" cy="4.5" r="1.5" />
        <circle cx="5.5" cy="11.5" r="1.5" />
    </svg>
);

/** Bouton flottant "Personnaliser l'affichage" + nombre d'indicateurs masqués */
const DisplayPrefsFab = () => {
    const openPrefPanel = usePilotageRhStore((s) => s.openPrefPanel);
    const { hiddenCount } = useIndicatorsVisibility();

    return (
        <FloatingDockPortal slot="page">
            <Fab type="button" onClick={() => openPrefPanel()}>
                <SlidersIcon />
                Personnaliser l’affichage
                {hiddenCount > 0 && <Badge>{hiddenCount}</Badge>}
            </Fab>
        </FloatingDockPortal>
    );
};

export default DisplayPrefsFab;

const Fab = styled.button`
    /* rendu dans le dock (hors de PageRoot) : on réapplique la charte */
    ${prhTheme}
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px 10px 14px;
    background: var(--prh-card);
    color: var(--prh-violet-dark);
    border: 1px solid var(--prh-violet-line);
    border-radius: 22px;
    box-shadow: 0 4px 16px rgba(36, 36, 36, 0.14);
    font-size: var(--prh-font-base);
    font-weight: 600;
    cursor: pointer;

    &:hover {
        background: var(--prh-violet-bg);
    }
    svg {
        display: block;
    }
`;

const Badge = styled.span`
    background: var(--prh-violet);
    color: #fff;
    border-radius: 10px;
    font-size: 11.5px;
    font-weight: 600;
    padding: 1px 7px;
    min-width: 20px;
    text-align: center;
`;
